export const EMAIL_RULE = /^[A-Z0-9._'%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const SPECIAL_CHARACTER_RULE = /[^A-Za-z0-9]+/
export const NUMBER_RULE = /[0-9]+/
export const UPPERCASE_RULE = /[A-Z]+/
export const LOWERCASE_RULE = /[a-z]+/
